<template>
  <loadingIcon v-if="loading" />
  <div v-else-if="!ads.length" class="tab-cnt prdt-list">
    <div class="noads-data">
      <img src="../assets/images/nodata.svg" alt="" />
      <p>Create ad for your Promotion</p>
      <button class="button " @click="$emit('createAd')">
        Create Ad
      </button>
    </div>
  </div>
  <div v-else-if="ads.length" class="tab-cnt prdt-list">
    <ul>
      <li
        v-for="(ad, index) in ads"
        :key="index"
        @click.prevent="
          $router.push(`/ad-details?AdNo=${ad.campaignIdentifier}`)
        "
      >
        <span class="img-box">
          <img
            :src="ad.campaignMedia[0].mediaURL"
            v-if="ad.campaignMedia.length"
          />
          <img v-else src="../assets/images/demo-img.jpg" alt="" />
        </span>
        <div class="title-blk">
          <h2>
            {{ ad.name }}
          </h2>
          <span class="text-date">{{ extractDate(ad.startDate) }}</span>
          <span
            class="status"
            :class="new Date().getTime() > ad.endDate ? 'expire' : 'active'"
          >
            {{ new Date().getTime() > ad.endDate ? "Expired" : "Active" }}
          </span>
        </div>

        <p>
          {{ ad.description }}
        </p>

        <div class="button-box">
          <!-- <div class="item">
            Selling Price:<strong>{{ ad.sellingPrice }}</strong>
          </div> -->

          <div class="item">
            <!-- <button
              class="button"
              :class="{ disable: new Date().getTime() > ad.endDate }"
            >
              Buy Now
            </button> -->
            <!-- button -->
            <button
              :id="`btn${index}`"
              class="button delete-btn"
              @click.stop="adsDelete(ad.campaignIdentifier, index)"
            >
              Delete
            </button>
          </div>
        </div>
      </li>
    </ul>
    <Toaster :dataValue="toasterData" />
  </div>
</template>
<script>
import loadingIcon from "./icons/loadingIcon";
import Toaster from "./Toaster";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
  name: "YourAds",
  data() {
    return {
      loading: false,
      toasterData: {},
      disable: false,
      selectedIndex: null,
    };
  },
  mounted() {},
  computed: {
    ...mapState(["adsTransaction", "ads"]),
  },
  components: {
    loadingIcon,
    Toaster,
  },
  methods: {
    adsDelete(identifier, index) {
      document.getElementById(`btn${index}`).classList.add("disable");
      this.$store
        .dispatch({ type: "AdsDelete", payload: identifier })
        .then((data) => {
          console.log("=data=deleted", data);
          if (data.httpStatus) {
            this.toasterData = {
              status: true,
              msg: data.message,
              timeoutMs: "5000",
              color: "#ff6600",
            };
            this.adsList(index);
          }
        });
    },
    adsList(index) {
      this.$store.dispatch({ type: "Adslist" }).then((data) => {
        if (data.httpStatus === 200) {
          document.getElementById(`btn${index}`).classList.remove("disable");
          this.$store.commit("adsList", data.data);
          // this.$router.replace("/dashboard");
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
    extractDate(timestamp) {
      const month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      return (
        new Date(timestamp).getDate() +
        " " +
        month[new Date(timestamp).getMonth()] +
        " " +
        new Date(timestamp).getFullYear()
      );
    },
  },
};
</script>
